(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabric-faq-searchable-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('#faq-root');
    if (!root) return;

    //const sections    = root.querySelectorAll('.faq-section');
    let sections = [];
    const navButtons  = root.querySelectorAll('.faq-nav-btn');
    const items       = root.querySelectorAll('.faq-item');
    const searchInput = root.querySelector('#faq-search-input');
    const searchCount = root.querySelector('#faq-search-count');
    const emptyState  = root.querySelector('#faq-empty');
    const totalCount  = items.length;

    /* =========================
      SORT BY ORDER (runs once on load)
      ========================= */
    function sortSectionsAndItems() {
      const wrapper = root.querySelector('#faq-sections-wrap');
      if (!wrapper) return sections;

      const sectionArr = Array.from(wrapper.querySelectorAll('.faq-section'));

      // Sort FAQ items inside each section
      sectionArr.forEach(section => {
        Array.from(section.querySelectorAll(':scope > .faq-item'))
          .sort((a, b) => (parseInt(a.dataset.order, 10) || 99) - (parseInt(b.dataset.order, 10) || 99))
          .forEach(el => section.appendChild(el));
      });

      // Sort sections (WITHOUT breaking structure)
      const sorted = sectionArr.sort(
        (a, b) => (parseInt(a.dataset.order, 10) || 99) - (parseInt(b.dataset.order, 10) || 99)
      );

      // Append back safely
      sorted.forEach(sec => wrapper.appendChild(sec));

      return sorted;
    }

    const sortedSections = sortSectionsAndItems();
    sections = sortedSections;

    /* =========================
      INIT STATE (ALL FILTER)
      ========================= */
    function initAllState() {
      sortedSections.forEach((section, index) => {
        const contents =
          section._contents ||
          (section._contents = section.querySelectorAll(':scope > *:not(.faq-section-title)'));

        if (index === 0) {
          section.classList.remove('collapsed');

          contents.forEach(el => {
            el.style.display = 'block';
            el.style.height  = 'auto';
            el.style.opacity = '1';
          });
        } else {
          section.classList.add('collapsed');

          contents.forEach(el => {
            el.style.display = 'none';
            el.style.height  = '0px';
            el.style.opacity = '0';
          });
        }
      });
    }

    initAllState();

    /* =========================
      SECTION TOGGLE (SMOOTH)
      ========================= */
    function toggleSection(section) {
      const contents =
        section._contents ||
        (section._contents = section.querySelectorAll(':scope > *:not(.faq-section-title)'));

      const isCollapsed = section.classList.contains('collapsed');

      contents.forEach(el => {
        if (isCollapsed) {
          // EXPAND
          el.style.display = 'block';

          const targetHeight = el.scrollHeight + 'px';

          el.style.display = 'none';
          el.style.height  = '0px';

          el.offsetHeight;

          el.style.display = 'block';
          el.style.height  = targetHeight;
          el.style.opacity = '1';

          setTimeout(() => {
            el.style.height = 'auto';
          }, 350);

        } else {
          // COLLAPSE
          const currentHeight = el.scrollHeight + 'px';

          el.style.display = 'block';
          el.style.height  = currentHeight;

          el.offsetHeight;

          el.style.height  = '0px';
          el.style.opacity = '0';

          setTimeout(() => {
            el.style.display = 'none';
          }, 350);
        }
      });

      section.classList.toggle('collapsed');
    }

    /* =========================
      CLOSE ALL OPEN FAQ ITEMS
      ========================= */
    function closeAllItems() {
      items.forEach(item => {
        if (item.classList.contains('open')) {
          item.classList.remove('open');
          const question = item.querySelector('.faq-question');
          if (question) question.setAttribute('aria-expanded', 'false');
          const answer = item.querySelector('.faq-answer');
          if (answer) answer.setAttribute('aria-hidden', 'true');
        }
      });
    }

    /* =========================
      SECTION TITLE CLICK
      ========================= */
    root.addEventListener('click', function (e) {
      const title = e.target.closest('.faq-section-title');
      if (!title) return;

      closeAllItems();

      const section = title.closest('.faq-section');
      if (section) toggleSection(section);
    });

    /* =========================
      FAQ ITEM TOGGLE
      ========================= */
    root.addEventListener('click', function (e) {
      const question = e.target.closest('.faq-question');
      if (!question) return;

      const item   = question.closest('.faq-item');
      if (!item) return;

      const isOpen = item.classList.contains('open');

      item.classList.toggle('open', !isOpen);
      question.setAttribute('aria-expanded', String(!isOpen));

      const answer = item.querySelector('.faq-answer');
      if (answer) {
        answer.setAttribute('aria-hidden', String(isOpen));
      }
    });

    /* =========================
      CATEGORY FILTER NAV
      ========================= */
    navButtons.forEach(btn => {
      btn.addEventListener('click', function () {

        closeAllItems();

        // Reset search
        if (searchInput) searchInput.value = '';
        updateSearchCount(totalCount);
        items.forEach(item => item.classList.remove('hidden'));

        const target = this.getAttribute('data-section');

        navButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        if (target === 'all') {
          sections.forEach(section => section.classList.remove('hidden'));
          initAllState();
        } else {
          sections.forEach(section => {
            if (section.id === target) {
              section.classList.remove('hidden', 'collapsed');

              const contents =
                section._contents ||
                (section._contents = section.querySelectorAll(':scope > *:not(.faq-section-title)'));

              contents.forEach(el => {
                el.style.display = 'block';
                el.style.height  = 'auto';
                el.style.opacity = '1';
              });
            } else {
              section.classList.add('hidden');
            }
          });
        }
      });
    });

    /* =========================
      SEARCH
      ========================= */
    function updateSearchCount(visible) {
      if (searchCount) {
        searchCount.textContent = 'Showing ' + visible + ' of ' + totalCount + ' questions';
      }
    }

    function showEmptyState(show) {
      if (emptyState) emptyState.style.display = show ? 'block' : 'none';
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        const term = this.value.trim().toLowerCase();

        if (!term) {
          items.forEach(item => item.classList.remove('hidden'));
          sections.forEach(section => section.classList.remove('hidden'));
          updateSearchCount(totalCount);
          showEmptyState(false);

          const activeBtn = root.querySelector('.faq-nav-btn.active');
          if (activeBtn) activeBtn.click();

          return;
        }

        // Reset filters during search
        navButtons.forEach(b => b.classList.remove('active'));

        sections.forEach(section => {
          section.classList.remove('hidden', 'collapsed');

          const contents =
            section._contents ||
            (section._contents = section.querySelectorAll(':scope > *:not(.faq-section-title)'));

          contents.forEach(el => {
            el.style.display = 'block';
            el.style.height  = 'auto';
            el.style.opacity = '1';
          });
        });

        let visibleCount = 0;

        items.forEach(item => {
          const questionText = (item.getAttribute('data-q') || '').toLowerCase();
          const answerEl     = item.querySelector('.faq-answer-inner');
          const answerText   = answerEl ? answerEl.textContent.toLowerCase() : '';

          const matches = questionText.includes(term) || answerText.includes(term);

          item.classList.toggle('hidden', !matches);

          if (matches) visibleCount++;
        });

        sections.forEach(section => {
          const hasVisible = section.querySelector('.faq-item:not(.hidden)');
          section.classList.toggle('hidden', !hasVisible);
        });

        updateSearchCount(visibleCount);
        showEmptyState(visibleCount === 0);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${
          this.header.offsetHeight
        }px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        


        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          


          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        


        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        


        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        


        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-discover_by_region"] && !Shopify.designMode) return;
  try {
    
  const slider_discover = document.querySelector('.dicoverContainer');
  let discover_isDown = false;
  let discover_startX;
  let discover_scrollLeft;

  slider_discover.addEventListener('mousedown', (e) => {
    discover_isDown = true;
    slider_discover.classList.add('active');
    discover_startX = e.pageX - slider_discover.offsetLeft;
    discover_scrollLeft = slider_discover.scrollLeft;
  });
  slider_discover.addEventListener('mouseleave', () => {
    discover_isDown = false;
    slider_discover.classList.remove('active');
  });
  slider_discover.addEventListener('mouseup', () => {
    discover_isDown = false;
    slider_discover.classList.remove('active');
  });
  slider_discover.addEventListener('mousemove', (e) => {
    if(!discover_isDown) return;
    e.preventDefault();
    const discover_x = e.pageX - slider_discover.offsetLeft;
    const discover_walk = (discover_x - discover_startX) * 3; //scroll-fast
    slider_discover.scrollLeft = discover_scrollLeft - discover_walk;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-new_arrival"] && !Shopify.designMode) return;
  try {
    
    const newArrival_slider = document.querySelector('#slick1');
  let newArrival_isDown = false;
  let newArrival_startX;
  let newArrival_scrollLeft;

  newArrival_slider.addEventListener('mousedown', (e) => {
    newArrival_isDown = true;
    newArrival_startX = e.pageX - newArrival_slider.offsetLeft;
    newArrival_scrollLeft = newArrival_slider.scrollLeft;
  });
  newArrival_slider.addEventListener('mouseleave', () => {
    newArrival_isDown = false;

  });
  newArrival_slider.addEventListener('mouseup', () => {
    newArrival_isDown = false;

  });
  newArrival_slider.addEventListener('mousemove', (e) => {
    if(!newArrival_isDown) return;
    e.preventDefault();
    const newArrival_x = e.pageX - newArrival_slider.offsetLeft;
    const newArrival_walk = (newArrival_x - newArrival_startX) * 3; //scroll-fast
    newArrival_slider.scrollLeft = newArrival_scrollLeft - newArrival_walk;
    console.log(newArrival_walk);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-curios"] && !Shopify.designMode) return;
  try {
    
  // const curious_slider = document.querySelector('.new_curios .row');
  // let curious_isDown = false;
  // let curious_startX;
  // let curious_scrollLeft;

  // curious_slider.addEventListener('mousedown', (e) => {
  //   curious_isDown = true;

  //   curious_startX = e.pageX - curious_slider.offsetLeft;
  //   curious_scrollLeft = curious_slider.scrollLeft;
  // });

  // curious_slider.addEventListener('mouseleave', () => {
  //   curious_isDown = false;
  // });

  //   curious_slider.addEventListener('mouseup', () => {
  //   curious_isDown = false;
  // });

  //   curious_slider.addEventListener('mousemove', (e) => {
  //   if(!curious_isDown) return;
  //   e.preventDefault();
  //   const curious_x = e.pageX - curious_slider.offsetLeft;
  //   const curious_walk = (curious_x - curious_startX) * 3; //scroll-fast
  //   curious_slider.scrollLeft = curious_scrollLeft - curious_walk;
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-info-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.info-slider').slick({
  infinite: true,         // loop enabled
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2500,
  cssEase: 'ease-in-out',
  draggable: true,
  swipe: true,
  touchMove: true
});

});

  } catch(e) { console.error(e); }
})();
})();
